
import { useState } from 'react';
import Hero from './components/Hero';
import Fleet from './components/Fleet';
import BookingProcess from './components/BookingProcess';
import WhyChooseUs from './components/WhyChooseUs';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';

export default function Home() {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "AutoRental",
    "name": "Car2Go",
    "description": "Professional car rental company providing premium vehicle rental services for business and leisure travelers in East Brunswick, New Jersey",
    "url": import.meta.env.VITE_SITE_URL || "https://www.cartogo.co",
    "telephone": "+1 (732) 900-3478",
    "email": "info@cartogo.co",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "28 Hollis Rd",
      "addressLocality": "East Brunswick",
      "addressRegion": "NJ",
      "postalCode": "08816",
      "addressCountry": "US"
    },
    "foundingDate": "2021",
    "openingHours": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        "opens": "06:00",
        "closes": "22:00"
      }
    ],
    "priceRange": "$35-$150",
    "brand": {
      "@type": "Brand",
      "name": "Car2Go"
    },
    "serviceType": "Car Rental",
    "areaServed": {
      "@type": "State",
      "name": "New Jersey"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Car Rental Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Economy Car Rental",
            "description": "Affordable economy cars for daily transportation"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Luxury Car Rental",
            "description": "Premium luxury vehicles for special occasions"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "SUV Rental",
            "description": "Spacious SUVs for family trips and group travel"
          }
        }
      ]
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="East Brunswick Car Rental | Car2Go Professional Vehicle Rentals NJ"
        description="Car2Go offers professional car rental services in East Brunswick, New Jersey since 2021. Premium economy cars, luxury sedans, SUVs for business and leisure. Licensed NJ car rental company with competitive rates and excellent service."
        keywords="East Brunswick car rental, New Jersey car rental, professional vehicle rental, business car rental, luxury car rental"
        canonical={`${import.meta.env.VITE_SITE_URL || "https://www.cartogo.co"}/`}
        ogTitle="Car2Go - Professional Car Rental East Brunswick NJ"
        ogDescription="Licensed car rental company in East Brunswick, NJ offering premium vehicles for business and leisure travel since 2021. Professional service with competitive rates."
        schemaData={schemaData}
      />
      <Hero />
      <Fleet />
      <BookingProcess />
      <WhyChooseUs />
      <Footer />
    </div>
  );
}